//Generated File 
export const Param_AvgValue = `AvgValue`;
export const Param_Category = `Category`;
export const Param_Color = `color`;
export const Param_ColumnCategory = `ColumnCategory`;
export const Param_ColumnLabel = `ColumnLabel`;
export const Param_ColumnValue = `ColumnValue`;
export const Param_ColumnsWidths = `ColumnsWidths`;
export const Param_FinalColumnsOrder = `FinalColumnsOrder`;
export const Param_FromDate = `FromDate`;
export const Param_FromDateTime = `FromDateTime`;
export const Param_FromTime = `FromTime`;
export const Param_GaugeBands = `GaugeBands`;
export const Param_GuageUnit = `GuageUnit`;
export const Param_HIDDEN_COLUMNS = `HiddenColumns_CSV`;
export const Param_HTMLArabicTemplate = `HTMLArabicTemplate`;
export const Param_HTMLEnglishTemplate = `HTMLEnglishTemplate`;
export const Param_HTMLOpenInIFrame = `HTMLOpenInIFrame`;
export const Param_INHTML = `INHTML`;
export const Param_Label = `Label`;
export const Param_Link = `Link`;
export const Param_LinkToID = `LinkToID`;
export const Param_LinkToType = `LinkToType`;
export const Param_MatrixPointText = `MatrixPointText`;
export const Param_OpenLinkInNewTab = `openLinkInNewTab`;
export const Param_ParentResourceID = `ParentResourceID`;
export const Param_PieLabel = `PieLabel`;
export const Param_PieValue = `PieValue`;
export const Param_PlotBands = `PlotBands`;
export const Param_PointName = `PointName`;
export const Param_RangeFrom = `RangeFrom`;
export const Param_RangeTo = `RangeTo`;
export const Param_ResourceID = `ResourceID`;
export const Param_ResourceName = `ResourceName `;
export const Param_Stack = `Stack`;
export const Param_Style = `Style`;
export const Param_TableArabicHeader = `TableArabicHeader`;
export const Param_TableBorderWidth = `TableBorderWidth`;
export const Param_TableEnglishHeader = `TableEnglishHeader`;
export const Param_Title = `Title`;
export const Param_ToDate = `ToDate`;
export const Param_ToDateTime = `ToDateTime`;
export const Param_ToTime = `ToTime`;
export const Param_ToolTipInfo = `ToolTipInfo`;
export const Param_URL = `URL`;
export const Param_Value = `Value`;
export const Param_XCategory = `xCategory`;
export const Param_YCategory = `yCategory`;
export const Param_maxTime = `maxTime`;
export const Param_minTime = `minTime`;
